import { render, staticRenderFns } from "./SaleInvoiceDefault.vue?vue&type=template&id=2c7c2deb&"
import script from "./SaleInvoiceDefault.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports